import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { IntlProvider } from 'react-intl';

import App from './components/App';
import ScrollToTop from './components/ScrollToTop';

// import registerServiceWorker from './registerServiceWorker';
import './index.css';

// Localization
import { loadI18n, configureClientLocales, detectBrowserLocale } from './i18n';

// import polyfillParticles from './utils/polyfillParticles';
// polyfillParticles();

async function startClient() {
  await configureClientLocales();
  
  const locale = detectBrowserLocale();

  ReactDOM.render(
    <IntlProvider
      locale={locale}
      messages={loadI18n(locale)}>
      <Router>
        <ScrollToTop>
          <Route path="/" component={App}/>
        </ScrollToTop>
      </Router>
    </IntlProvider>,
    document.getElementById('root')
  );
}

startClient();
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js